import { clsx } from 'clsx'
import { twJoin, twMerge } from 'tailwind-merge'
import type { ClassValue } from 'clsx'

// cn = join + resolve Tailwind conflicts (twMerge). Use when merging an incoming
// `className` prop or when conflicting utilities must override each other
// (the shadcn pattern).
export function cn(...inputs: Array<ClassValue>) {
    return twMerge(clsx(inputs))
}

// twJoin = plain join (drops falsy), NO conflict resolution. Prefer this to
// split a long, self-owned className into readable blocks — it is lighter and
// has no override "magic". Reach for cn() only when conflicts/overrides matter.
export { twJoin }
